import { render, staticRenderFns } from "./Po.vue?vue&type=template&id=572228ff&"
import script from "./Po.vue?vue&type=script&lang=js&"
export * from "./Po.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Po.vue"
export default component.exports